import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=66ba336b&scoped=true"
import script from "./legal.vue?vue&type=script&lang=js"
export * from "./legal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba336b",
  null
  
)

export default component.exports